import React from 'react'
import './Card.css'
import logo from './Vedio.png'
import './Navbar.css'

const Card = (props) => {
  return (
<div>

<div className="card horizontal-card1" id="card10"style={{borderRadius: props.radius}}>
  <div className="card-content10">
    <span className="text10">{props.number}</span>
    <a href={props.link}>
      <img src={logo} id='img10' alt="Image" style={{width:'100px',height:'50px'}} />
    </a>
    <a href={props.link} className="card-text10">{props.desc}</a>
    <p id='p10'>{props.text}</p>
  </div>
</div>

</div>



  )
}

export default Card